import { Component, inject, signal, effect } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../../services/authentication.service';
import { I18nService } from '../../services/i18n.service';
import { LegalLocalizationService } from '../../services/legal-localization-service';
import { SettingsService } from '../../services/settings.service';
import { ScrollToTopComponent } from '../../components/scroll-to-top/scrollToTop';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { NavButtonComponent } from '../../components/nav-button/nav-button';
import { App_Routes } from '../../enums/router.enum';

@Component({
  selector: 'app-service-conditions',
  imports: [ScrollToTopComponent, NavButtonComponent],
  templateUrl: './service-conditions.html',
  styleUrl: './service-conditions.scss',
})
export class ServiceConditions {
  public i18n = inject(I18nService);
  private router = inject(Router);
  private auth = inject(AuthenticationService);
  private settingsService = inject(SettingsService);
  private lls = inject(LegalLocalizationService);

  showUSCountryPage = signal(false);
  showLatamCountryPage = signal(false);
  isAuth = signal(this.auth.isLoggedIn());

  scopesDefault: any[] = [];
  scopesLatam: any[] = [];

  constructor() {
    if (this.lls?.checkForUS()) {
      this.showUSCountryPage.set(true);
    }

    effect(() => {
      if (this.lls?.signedUpCountry() === GLOBAL_CONSTANT.COUNTRY_CODE_46)
        this.showLatamCountryPage.set(true);
    });
  }

  gotoLogin() {
    if (this.router.url.includes('settings')) {
      this.router.navigate([App_Routes.SETTINGS]);
    } else {
      this.router.navigate([App_Routes.LOGIN]);
    }
  }
}
